import React from "react";
import { CheckboxBlock } from "./styled";
import { Text } from "../../../styled";
import greenOk from "./../../../resources/images/utils/green_ok.svg";
import whiteOk from "./../../../resources/images/utils/white_ok.svg";

const Checkbox = (props) => {
  const { text, isActive, setActiveFunction, isMain } = props;

  const handleClick = () => {
    setActiveFunction();
  };

  return (
    <CheckboxBlock
      onClick={handleClick}
      isActive={isActive}
      isMain={isMain}
      className={isMain ? "main" : null}
    >
      <CheckboxBlock.Point isActive={isActive}>
        <CheckboxBlock.Point.Round
          isActive={isActive}
          className={isMain ? "main" : null}
        >
          {isActive !== undefined && (
            <img src={isMain ? whiteOk : greenOk} alt="" />
          )}
        </CheckboxBlock.Point.Round>
      </CheckboxBlock.Point>
      <CheckboxBlock.Text isActive={isActive}>
        <Text className={isMain ? "main" : null}>{text}</Text>
      </CheckboxBlock.Text>
    </CheckboxBlock>
  );
};

export default Checkbox;
